import React, { Component } from "react";
import { ReactComponent as OptionsSvg } from "../../images/more-options.svg";
import { ReactComponent as FolderSvg } from "../../images/folder-regular.svg";
import { Dropdown } from "react-bootstrap";

export default class OptionsDropdown extends Component {
    state = {
        show: false,
        deleteSelected: false,
    };

    dismissDropdown() {
        this.setState({
            show: false,
            deleteSelected: false,
        })
    }

    render() {
        const { options, onItemClick, onDelete } = this.props;
        const { deleteSelected, show } = this.state;

        return (
            <Dropdown
                show={show}
                onToggle={(show, meta) => {
                    if (meta?.source !== 'select') {
                        this.setState({
                            show,
                            deleteSelected: false,
                        });
                    }
                }}
            >
                <Dropdown.Toggle as={CustomToggle} id="options-dropdown" />
                <Dropdown.Menu style={{ borderRadius: '12px' }} className="py-0 overflow-hidden">
                    {!deleteSelected ? <>
                        {options?.length > 0 && <>
                            <Dropdown.ItemText className="px-3 py-2">
                                <div className="d-flex align-items-center">
                                    <FolderSvg />
                                    <span className="ms-2">Move To:</span>
                                </div>
                            </Dropdown.ItemText>
                            <Dropdown.Divider className="my-0" />
                        </>}
                        {options?.map((option, idx) => (
                            <div key={option.id}>
                                <Dropdown.Item
                                    eventKey={idx}
                                    className="px-3 py-2"
                                    onClick={() => {
                                        onItemClick(option.id);
                                        this.dismissDropdown();
                                    }}
                                >
                                    {option.name}
                                </Dropdown.Item>
                                <Dropdown.Divider className="my-0" />
                            </div>
                        ))}
                        <Dropdown.Item
                            eventKey='delete'
                            className="px-3 py-2 text-danger"
                            onClick={() => this.setState({ deleteSelected: true })}
                        >
                            Delete
                        </Dropdown.Item>
                        </>
                        : <ConfirmDeleteDialog
                            cancelAction={this.dismissDropdown.bind(this)}
                            confirmAction={() => {
                                onDelete();
                                this.dismissDropdown();
                            }}
                        />}
                </Dropdown.Menu>
            </Dropdown>
        )
    }
}

const CustomToggle = React.forwardRef(function ({ onClick }, ref) {
    return <OptionsSvg
        ref={ref}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
        style={{ cursor: 'pointer' }}
    />
});

class ConfirmDeleteDialog extends Component {
    render() {
        const { cancelAction, confirmAction } = this.props;

        return <>
            <Dropdown.ItemText className="px-3 py-2">
                Are you sure?
            </Dropdown.ItemText>
            <Dropdown.ItemText className="px-3 pb-2 pt-0">
                <i style={{ fontSize: '14px' }}>This will delete this forever.</i>
            </Dropdown.ItemText>
            <Dropdown.Divider className="my-0" />
            <div className="d-flex align-items-center justify-content-between">
                <Dropdown.Item
                    eventKey='cancel'
                    onClick={cancelAction}
                >
                    Cancel
                </Dropdown.Item>
                <Dropdown.Item
                    eventKey='confirm'
                    className="text-danger"
                    onClick={confirmAction}
                >
                    Delete
                </Dropdown.Item>
            </div>
        </>
    }
}